var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tags-area",style:({ 'margin-top': _vm.isOwnerSearch ? '5px' : '20px' })},[(!_vm.isOwnerSearch)?_c('div',{staticClass:"label"},[_vm._v("タグ")]):_vm._e(),_c('div',{staticClass:"tags"},_vm._l((_vm.tags),function(tag){return _c('div',{key:tag.id,class:{
        tag: true,
        'tag-hover': !_vm.tagEditAreaShowFlg,
        selected: _vm.value.includes(tag.id)
      },attrs:{"data-test":"tag"},on:{"click":function($event){return _vm.handleClick(tag.id)}}},[_vm._v(" "+_vm._s(tag.name)+" ")])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }